import { ActionTypes } from "../../constants/ActionTypes";

// newLetter
export const onCreateLetter = (letterTemlateId: string) => {
    return {
        type: ActionTypes.CREATE_LETTER,
        payload: letterTemlateId
    };
};

export const onCreateNewLetterSuccess = (action: any) => {
    return {
        type: ActionTypes.CREATE_LETTER_SUCCESS,
        payload: action.data,
    };
};
